import * as Blockly from 'blockly/core';
// import { VmtFieldFlyoutText } from '../fields/VmtFlyout/VmtFlyoutEditField';
// import { createMinusField } from '../fields/field_minus';
// import { createPlusField } from '../fields/field_plus';
import { getExtraBlockState } from '../fields/serialization_helper';
import './vmt_parameter';
import './vmt_param_drop';
import './vmt_parameter_reference';
import './vmt_return_decoration';
import { wrapBlockWith, unwrapBlock, getRbReturnValueBlockState } from './blocks_helpers';
import { Colors } from '../../const';

const REUSABLE_BRICK_COLOR = Colors.REUSABLE_BRICK_COLOR; //'#138D90';

// const plusImage =
//     'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC' +
//     '9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48cGF0aCBkPSJNMT' +
//     'ggMTBoLTR2LTRjMC0xLjEwNC0uODk2LTItMi0ycy0yIC44OTYtMiAybC4wNzEgNGgtNC4wNz' +
//     'FjLTEuMTA0IDAtMiAuODk2LTIgMnMuODk2IDIgMiAybDQuMDcxLS4wNzEtLjA3MSA0LjA3MW' +
//     'MwIDEuMTA0Ljg5NiAyIDIgMnMyLS44OTYgMi0ydi00LjA3MWw0IC4wNzFjMS4xMDQgMCAyLS' +
//     '44OTYgMi0ycy0uODk2LTItMi0yeiIgZmlsbD0id2hpdGUiIC8+PC9zdmc+Cg==';

// const minusImage =
//     'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAw' +
//     'MC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48cGF0aCBkPS' +
//     'JNMTggMTFoLTEyYy0xLjEwNCAwLTIgLjg5Ni0yIDJzLjg5NiAyIDIgMmgxMmMxLjEwNCAw' +
//     'IDItLjg5NiAyLTJzLS44OTYtMi0yLTJ6IiBmaWxsPSJ3aGl0ZSIgLz48L3N2Zz4K';

//==================================================================================================
//==================================================================================================

function createParameterBlockState(refParamData) {
    return {
        // block: {
        type: 'vmt_RB_param_control',
        id: Blockly.utils.idGenerator.genUid(),
        data: {
            paramId: refParamData.paramId
        },
        deletable: false,
        movable: false,
        fields: {
            PARAM_NAME: refParamData.name,
            INDENT: " ",
        }
        // }
    };
} // end createParameterBlockState 

/**
 * @param {Blockly.Block} rbBlock The reusable block to update.
 * @param {Array<{name:string, paramId:string}>} blockParams The parameter data to update. 
 */
function updateRefReusableBlocks(rbBlock, blockParams) {
    // update the parameter reference blocks to point to the new parameter blocks
    console.log('updateRefReusableBlocks');
    console.log('updateRefReusableBlocks', rbBlock.id, blockParams);
    // if (!blockParams) return;

    // const paramIdsMap = new Map(blockParams.map(param => [param.paramId, null]));
    const paramIdsMap = new Map();
    let maxParamNameLength = 0;
    for (const param of blockParams) {
        maxParamNameLength = Math.max(maxParamNameLength, param.name.length);
        paramIdsMap.set(param.paramId, null);
    }

    const ws = rbBlock.workspace;
    const reusableRefBlocks = ws.getAllBlocks().filter(block => block.type === 'vmt_RB_ref_no_return' && block.data && block.data.ref.id === rbBlock.id);
    // iterate over the reusable reference blocks and update the parameter blocks
    reusableRefBlocks.forEach(refBlock => {
        const refBlockState = Blockly.serialization.blocks.save(refBlock, { addNextBlocks: false });
        const parametersConnState = refBlockState?.inputs?.PARAMETERS;
        /**
         * @type {Array<{block: Blockly.serialization.blocks.State, value: Blockly.serialization.blocks.ConnectionState}>}
         */
        let isUpdateRequired = false;
        const deletedParamBlocks = [];
        let refParamBlockState = parametersConnState?.block;
        while (refParamBlockState) {
            const refParamId = refParamBlockState?.data?.paramId;
            if (paramIdsMap.has(refParamId)) { // rename the parameter name if it is not the same as the new one
                const paramName = refParamBlockState?.fields?.PARAM_NAME;
                const newParamName = blockParams.find(param => param.paramId === refParamId).name;
                if (newParamName !== paramName) {
                    refParamBlockState.fields.PARAM_NAME = newParamName;
                    isUpdateRequired = true;
                }
                paramIdsMap.set(refParamId, refParamBlockState);
            }
            else {
                // store parameter block state to delete it later
                const paramValue = refParamBlockState?.inputs?.VALUE || null;
                deletedParamBlocks.push({
                    block: refParamBlockState,
                    value: paramValue
                });
            }
            refParamBlockState = refParamBlockState?.next?.block;
        }

        paramIdsMap.forEach((paramBlockState, paramId) => {
            if (paramBlockState === null) {
                const newParamBlockState = createParameterBlockState(blockParams.find(param => param.paramId === paramId));
                paramIdsMap.set(paramId, newParamBlockState);
                refBlockState.inputs = { PARAMETERS: {} };
                refBlockState.inputs.PARAMETERS.block = newParamBlockState;
                isUpdateRequired = true;
            }
        });

        isUpdateRequired = isUpdateRequired || deletedParamBlocks.length > 0;

        // update the parameter reference block with the new parameter blocks
        if (isUpdateRequired) {
            const prevGroupId = Blockly.Events.getGroup();
            Blockly.Events.setGroup(true);
            // diconnect next and previous connections
            const prevBlockConnection = refBlock.previousConnection?.targetConnection || null;
            const nextBlockConnection = refBlock.nextConnection?.targetConnection || null;
            refBlock.nextConnection?.disconnect();
            refBlock.previousConnection?.disconnect();
            // // destroy the block and create a new one with the updated state
            // refBlock.dispose(false);
            delete refBlockState.inputs.PARAMETERS.block;

            // recreate/construct the parameter blocks with the updated states
            let tailBlockState = null;
            for (const [paramId, paramBlockState] of paramIdsMap) {
                const paramData = blockParams.find(param => param.paramId === paramId);
                const indent = ' '.repeat(maxParamNameLength - paramData.name.length + 1);
                paramBlockState.fields.INDENT = indent;
                delete paramBlockState.next;
                if (tailBlockState) {
                    tailBlockState.next = { block: paramBlockState };
                    tailBlockState = tailBlockState.next.block;
                }
                else {
                    refBlockState.inputs.PARAMETERS = { block: paramBlockState };
                    tailBlockState = refBlockState.inputs.PARAMETERS.block;
                }
            }
            const newRefBlock = Blockly.serialization.blocks.append(refBlockState, ws, { recordUndo: true });
            // connect the new block to the previous and next connections
            prevBlockConnection && newRefBlock.previousConnection.connect(prevBlockConnection);
            nextBlockConnection && newRefBlock.nextConnection.connect(nextBlockConnection);
            // Try to render the control - otherwise will throw an exception in headless mode
            if (typeof newRefBlock.initSvg == "function") {
                newRefBlock.initSvg();
                newRefBlock.render();
            }

            // destroy the block and create a new one with the updated state
            refBlock.dispose(false);

            // // render Values (if any) of deleted parameter blocks
            // deletedParamBlocks.forEach(paramBlock => {
            //     const paramValue = paramBlock.value;
            //     if (paramValue) {
            //         const valueBlockState = paramValue.block;
            //         const valueBlock = Blockly.serialization.blocks.append(valueBlockState, ws);
            //         // // connect the new block to the previous and next connections
            //         // valueBlock.previousConnection.connect(paramBlock.block.previousConnection);
            //         // valueBlock.nextConnection.connect(paramBlock.block.nextConnection);
            //         // Try to render the control - otherwise will throw an exception in headless mode
            //         if (typeof valueBlock.initSvg == "function") {
            //             valueBlock.initSvg();
            //             valueBlock.render();
            //         }
            //     }
            // });
            // Blockly.Events.setGroup(false);
            Blockly.Events.setGroup(prevGroupId);
        }


        console.log('updateRefReusableBlocks', deletedParamBlocks);
        // console.log('updateRefReusableBlocks', refBlockState);
        console.log('updateRefReusableBlocks', paramIdsMap);
    });
}

/**
 * @param {Blockly.Block} rbBlock The reusable block to update.
 * @param {boolean} isReturnValue The return value state.
 */
function setRetValue4RefReusableBlocks_(rbBlock, isReturnValue) {
    console.log('setRetValue4RefReusableBlocks_', rbBlock, isReturnValue);
    const ws = rbBlock.workspace;

    if (isReturnValue) {
        const rbBlockVariableId = rbBlock.getSurroundParent().getField('VAR').getValue();
        const reusableRefBlocks = ws.getAllBlocks().filter(block => block.type === 'vmt_RB_ref_no_return' && block.data && block.data.ref.id === rbBlock.id);
        reusableRefBlocks.forEach(refBlock => {
            const returnWrapperBlockState = getRbReturnValueBlockState(rbBlock.id, rbBlockVariableId);
            wrapBlockWith(refBlock, returnWrapperBlockState, 'VALUE_STATEMENT');
        });
    }
    else {
        const reusableReturnRefBlocks = ws.getAllBlocks().filter(block => block.type === 'vmt_variables_set_reusable' && block.data && block.data.ref.id === rbBlock.id);
        reusableReturnRefBlocks.forEach(returnRefBlock => {
            unwrapBlock(returnRefBlock);
        });
    }
}

/**
 * Reusable brick block definition.
 * @type {{
*   init: Blockly.Blocks.vmt_reusable_brick_init.init
* }}
*/
Blockly.Blocks['vmt_reusable_brick_init_statement'] = {
    /** @type {Blockly.Input} */
    paramDropInput_: null,
    /** @type {Blockly.Block} */
    dropBlock_: null,
    /** @type {string} */
    prevBlockId_: null,
    /** @type {string} */
    prevInputName_: null,
    /** @type {string} */
    draggedBlockId_: null,
    /** @type {boolean} */
    isInsideReusableBlock_: false,
    /**
    * Initializes the block.
    * @this {Blockly.Block}
    */
    init: function () {
        this.jsonInit({
            // "type": "vmt_reusable_brick_init",
            message0: "%1 %2 %3",
            message1: "%1 %2",
            message2: "Is returning value %1%2",
            args0: [
                {
                    "type": "field_image",
                    "src": "media/images/recycling_40dp_FFFFFF_FILL0_wght400_GRAD0_opsz40.svg",
                    "width": 30,
                    "height": 30,
                    "alt": "♻",
                    "flipRtl": "FALSE"
                },
                {
                    // type: 'input_dummy',
                    type: 'input_value',
                    name: 'TOP',
                },
                {
                    "type": "field_input",
                    "name": "REUSABLE_BRICK_DESCIPTION",
                    "text": "<description>"
                },

            ],
            args1: [
                // {
                //     "type": "input_statement",
                //     "name": "PARAM_STATEMENT",
                //     // "check": ["Brick", "null"]
                // },
                {
                    "type": "input_statement",
                    "name": "REUSABLE_BRICK_STATEMENT",
                    "check": ["Brick", "null"]
                },
                {
                    type: 'input_dummy',
                    name: 'EMPTY',
                },
            ],
            args2: [
                {
                    "type": "field_checkbox",
                    "name": "IS_RETURN_VALUE",
                    "checked": "FALSE"
                },
                {
                    "type": "input_value",
                    "name": "RETURN_VALUE",
                    "check": ["null"]
                },
            ],

            previousStatement: ["Brick", "ReBlock", "null"],
            nextStatement: ["Brick", "ReBlock", "null"],
            colour: REUSABLE_BRICK_COLOR,
            tooltip: "",
            helpUrl: "",
            mutator: "new_statement_parameter_create_with_mutator"
        });

        this.paramDropInput_ = this.getInput('TOP');

        // Ensure the workspace is available before trying to add a child block
        if (!this.workspace) return;

        // Create a shadow block to be displayed in the block
        let shadowXml = Blockly.utils.xml.textToDom('<shadow type="vmt_param_drop"/>');
        this.paramDropInput_.setShadowDom(shadowXml); // Connect the shadow block to the input

        // Create a shadow block to be displayed in the block
        const retValInput = this.getInput("RETURN_VALUE"); // 
        shadowXml = Blockly.utils.xml.textToDom('<shadow type="vmt_return_decoration"/>');
        retValInput.setShadowDom(shadowXml); // Connect the shadow block to the input
        const retDecorationBlcok = retValInput.connection.targetBlock();
        retDecorationBlcok.data = JSON.stringify({ type: 'ret_dec', parentBlockId: this.id });

        // set validator for the checkbox field
        this.getField('IS_RETURN_VALUE').setValidator(this.validate);
    },

    /**
     * 
     * @param {'TRUE'|'FALSE'} state
     * @this {Blockly.FieldCheckbox}
     * @returns {'TRUE'|'FALSE'|null}
     */
    validate: function (state) {
        console.log('Validate', state);
        const thisBlock = this.getSourceBlock();
        const retValueInput = thisBlock.getInput('RETURN_VALUE');
        if (state === 'FALSE') {
            // disable the return value input
            retValueInput.connection.setCheck(['null']);
        }
        else {
            // enable the return value input
            retValueInput.setCheck(null);
        }
        thisBlock.updateShape__(state === 'TRUE');
        return state;
    },

    /**
     * Update the shape of the block based on the return value state.
     * @param {boolean} isReturnValue
     * @this {Blockly.Block} 
     */
    updateShape__: function (isReturnValue) {
        const dataIsReturnValue = this?.data?.isReturnValue ?? false;
        if (isReturnValue && dataIsReturnValue === false) {
            this.data = { isReturnValue: true };
            // diconnect next and previous connections
            const prevBlockConnection = this.previousConnection.targetConnection;
            const nextBlockConnection = this.nextConnection.targetConnection;
            this.previousConnection?.disconnect();
            this.nextConnection?.disconnect();
            // remove next statement connections
            this.setNextStatement(false);

            // create a new variable block
            const ws = this.workspace;
            const varModel = ws.createVariable('returnValue');
            console.log('varModel', varModel);
            const retValBlock = Blockly.serialization.blocks.append(
                {
                    'type': 'vmt_variables_set_reusable',
                    'fields': {
                        'VAR': {
                            'id': varModel.id,
                        },
                    },
                },
                ws,
            );
            const blockCoordinate = this.getRelativeToSurfaceXY();
            retValBlock.moveBy(blockCoordinate.x, blockCoordinate.y);
            // connect the set variable block to previous and next connections
            prevBlockConnection && retValBlock.previousConnection.connect(prevBlockConnection);
            nextBlockConnection && retValBlock.nextConnection.connect(nextBlockConnection);
            // place the reusable block inside the return value input satement
            retValBlock.getInput('VALUE_STATEMENT').connection.connect(this.previousConnection);
            this.setMovable(false);
            this.setDeletable(false);
            // Try to render the control - otherwise will throw an exception in headless mode
            if (typeof retValBlock.initSvg == "function") {
                retValBlock.initSvg();
                retValBlock.render();
            }
            setRetValue4RefReusableBlocks_(this, true);
        }
        else if (!isReturnValue && dataIsReturnValue === true) {
            this.data = { isReturnValue: false };
            this.setNextStatement(true, ["Brick", "ReBlock", "null"]);
            this.setMovable(true);
            this.setDeletable(true);
            // disconnect the return value input from the previous and next connections
            const retValBlock = this.previousConnection.targetBlock();
            const prevBlockConnection = retValBlock.previousConnection.targetConnection;
            const nextBlockConnection = retValBlock.nextConnection.targetConnection;
            retValBlock.previousConnection?.disconnect();
            retValBlock.nextConnection?.disconnect();
            // disconnect from the return value input
            this.previousConnection?.disconnect();
            // delete the return value input block
            retValBlock.dispose(true);
            // slot the reusable block into the retValBlock's previous and next connections
            prevBlockConnection && this.previousConnection.connect(prevBlockConnection);
            nextBlockConnection && this.nextConnection.connect(nextBlockConnection);
            setRetValue4RefReusableBlocks_(this, false);
        }
    },

    /**
     * Is this block enclosed (at any level) by a reusable block?
     * If so, return true, otherwise return false.
     * @param {string} blockId The block id to check if it is inside a reusable block.
     * @this {Blockly.Block}
     * @return {boolean} True if the block is inside a reusable block, false otherwise.
     */
    isInsideReusableBlock: function (blockId) {
        // const loopTypes = new Set(['vmt_reusable_brick_init', 'vmt_reusable_brick_init_statement']);
        let block = this.workspace.getBlockById(blockId);
        while (block) {
            if (block.id === this.id) {
                return true;
            }
            if (block.type === 'vmt_reusable_brick_init_statement') {
                return false;
            }
            block = block?.getSurroundParent();
        }
        return false;
    },

    /**
     * Gets the value of a control block if the block is inside a "brick" block.
     * @param {Blockly.Block} block The block
     * @this {Blockly.Block}
     * @private
     * @return {string|null} The name of the parameter block or null.
     */
    tryToGetParamName_: function (block) {
        let parentBlock = block.getSurroundParent();
        while (parentBlock) {
            if (parentBlock.type.startsWith('vmt_control')) {
                return parentBlock.getFieldValue('CONTROL_NAME').trim();//.getText();
            }
            parentBlock = parentBlock.getSurroundParent();
        }
        return null;
    },


    /**
     * check if the param drop is replaced by a new block
     * @param {Blockly.Events.Abstract} e Change event.
     * @this {Blockly.BlockSvg}
     * @private
     */
    onchange: function (e) {
        let block = null;
        switch (e.type) {
            case Blockly.Events.BLOCK_CREATE:
            case Blockly.Events.FINISHED_LOADING:
                // if (e?.ids?.includes(this.id))
                {
                    const paramDropBlock = this.getInputTargetBlock('TOP');
                    const plusField = paramDropBlock.getField('PLUS');
                    plusField.setOnClickHandler(this.plus.bind(this));
                }
                break;
            case Blockly.Events.BLOCK_DRAG:
                // console.log('BLOCK_DRAG', e);
                if (e.isStart) {
                    // reset the previous block and its position
                    this.prevBlockId_ = null;
                    this.isInsideReusableBlock_ = false;
                    this.draggedBlockId_ = e.blockId;
                    const draggedBlock = this.workspace.getBlockById(e.blockId);
                    this.startBlockLoc_ = draggedBlock.getRelativeToSurfaceXY();
                }
                break;
            case Blockly.Events.BLOCK_MOVE: // record the previous block and input name
                // console.log('BLOCK_MOVE', e);
                // if the drag has started, then record the previous block and input name
                // when the block is disconnected
                // if (this.startDrag_ && e.reason?.includes('disconnect') && !!e.oldParentId) {
                // if (this.startDrag_) {
                if (e.reason?.includes('disconnect') && !!e.oldParentId) {
                    block = this.workspace.getBlockById(e.blockId);
                    if (block && block.type !== 'vmt_param_drop' && e.oldInputName !== 'TOP') {
                        this.prevBlockId_ = e.oldParentId;
                        this.prevInputName_ = e.oldInputName;
                        // this.draggedBlockId_ = e.blockId;
                        this.isInsideReusableBlock_ = this.isInsideReusableBlock(e.oldParentId);
                        // console.log('>>BLOCK_MOVE', this.prevBlockId_, this.prevInputName_, this.draggedBlockId_, this.isInsideReusableBlock_);
                    }
                }
                else if (e.reason?.includes('connect') && e.newParentId === this.id && e.newInputName === "TOP") {
                    // !!! if the block is inside a reusable block, then add a new param block
                    if (this.isInsideReusableBlock_) {
                        const workspace = this.workspace;
                        const draggedBlock = workspace.getBlockById(this.draggedBlockId_);

                        let prevBlock = workspace.getBlockById(this.prevBlockId_);
                        let newParamName = null;
                        if (prevBlock) {
                            newParamName = this.tryToGetParamName_(prevBlock);
                        }
                        const { paramBlock, name, paramId } = this.addParam_(newParamName);
                        console.log('NEW PARAM', name, paramId, paramBlock);
                        paramBlock.getInput('PARAM_INPUT').connection.connect(draggedBlock.outputConnection);

                        try {
                            workspace.clearUndo();
                            Blockly.Events.setRecordUndo(false);
                            // create a new parameter reference block
                            const newParamRefBlock = workspace.newBlock('vmt_parameter_reference');
                            newParamRefBlock.getField('PARAMETER_NAME').setValue(name);
                            // newParamRefBlock.getField('PARENT_BLOCK_ID').setValue(this.id);
                            // newParamRefBlock.getField('PARAM_ID').setValue(paramId);
                            newParamRefBlock.data = JSON.stringify({ type: 'parameter_ref', name, paramId, parentBlockId: this.id });

                            // Try to render the control - otherwise will throw an exception in headless mode
                            if (typeof newParamRefBlock.initSvg == "function") {
                                newParamRefBlock.initSvg();
                                newParamRefBlock.render();
                            }

                            // let prevBlock = workspace.getBlockById(this.prevBlockId_);
                            if (prevBlock) {
                                prevBlock.getInput(this.prevInputName_).connection.connect(newParamRefBlock.outputConnection);
                            }
                        } finally {
                            Blockly.Events.setRecordUndo(true);
                        }
                    }
                    else {
                        // if the block is outside a reusable block, 
                        // then detach the block and connect it to the previous block if it is the case
                        console.log('<>NEED TO DETTACH >>vmt_param_drop<<', e);
                        try {
                            Blockly.Events.setRecordUndo(false);
                            this.paramDropInput_.connection.disconnect();
                            const workspace = this.workspace;
                            const draggedBlock = workspace.getBlockById(this.draggedBlockId_);
                            if (draggedBlock) {
                                if (this.prevBlockId_) { // return the block to its previous connection
                                    let prevBlock = workspace.getBlockById(this.prevBlockId_);
                                    if (prevBlock) {
                                        prevBlock.getInput(this.prevInputName_).connection.connect(draggedBlock.outputConnection);
                                    }
                                }
                                else { // return the block to its previous position
                                    draggedBlock.unplug();
                                    draggedBlock.setParent(null);
                                    draggedBlock.moveTo(this.startBlockLoc_, ['drag']);
                                }
                            }
                        } finally {
                            Blockly.Events.setRecordUndo(true);
                        }
                    }
                    this.isInsideReusableBlock_ = false;
                    this.prevBlockId_ = null;
                    this.prevInputName_ = null;
                    this.draggedBlockId_ = null;
                }
                break;
            default:
                // console.log('DEFAULT', e);
                break;
        }
    }
};


const statementParameterCreateMutator = {
    /**
     * An array of objects containing data about the params belonging to the
     * reusable block definition.
     * @type {!Array<{
     *          name:string,
     *          paramId: string
     *       }>}
     * @private
     */
    paramData_: [],
    timerId_: 0,

    /**
     * Returns the state of this block as a JSON serializable object.
     * @returns {{itemCount: number}} The state of this block, ie the item count.
     */
    saveExtraState: function () {
        // skip saving the state of the block for headless mode
        if (!("isVisible" in this.workspace)) {
            return null;
        }

        if (!this.paramData_.length && this.hasStatements_) {
            return null;
        }
        console.log('>>>saveExtraState', this.workspace.id, this.paramData_, this.hasStatements_);

        const state = Object.create(null);
        state['params'] = [];
        if (this.paramData_.length) {
            this.paramData_.forEach((param) => {
                state['params'].push({
                    name: param.name,
                    paramId: param.paramId,
                });
            });
        }
        if (!this.hasStatements_) {
            state['hasStatements'] = false;
        }

        // TODO: This is a workaround to avoid multiple calls to the updateRefReusableBlocks function
        //       but it is not the best solution as the Undo/Redo stack is not cleared, so stay with multiple calls;
        //       proper functioning over performance.
        // clearTimeout(this.timerId_);
        // this.timerId_ = setTimeout(() => {
        //     updateRefReusableBlocks(this, state['params'])
        // }, 10);
        updateRefReusableBlocks(this, state['params'])
        return state;
    },

    /**
     * Applies the given state to this block.
     * @param {*} state The state to apply to this block, ie the item count.
     */
    loadExtraState: function (state) {
        const names = [];
        const paramIds = [];
        if (state['params']) {
            for (let i = 0; i < state['params'].length; i++) {
                const param = state['params'][i];
                names.push(param['name']);
                paramIds.push(param['paramId']);
            }
        }
        this.updateShape_(names, paramIds);
    },

    /**
     * Adds inputs to the block until it reaches the target number of inputs.
     * Adds arguments to the block until it matches the targets.
     * @param {!Array<string>} names An array of argument names to display.
     * @param {!Array<string>} paramIds An array of parameter IDs associated with
     *     those names.
     * @this {Blockly.Block}
     * @private
     */
    updateShape_: function (names, paramIds) {
        if (names.length !== paramIds.length) {
            throw Error('names and paramIds must have the same length.');
        }

        if (this.data?.isReturnValue) {
            // remove next statement connections
            this.setNextStatement(false);
        }

        // add if we have got params
        if (names.length > 0) {
            // this.appendStatementInput('PARAM_STATEMENT');
            // this.moveInputBefore('PARAM_STATEMENT', 'REUSABLE_BRICK_STATEMENT');
            this.appendParamStatementInput_();
        }

        //     // Usually it's more efficient to modify the block, rather than tearing it
        //     // down and rebuilding (less render calls), but in this case it's easier
        //     // to just work from scratch.

        //     // We need to remove params in reverse order so that it doesn't mess up
        //     // as removeParams_ modifies our array.
        //     for (let i = this.paramData_.length - 1; i >= 0; i--) {
        //         this.removeParam_(this.paramData_[i].paramId);
        //     }
        this.paramData_ = [];
        const length = paramIds.length;
        for (let i = 0; i < length; i++) {
            // this.addParam_(names[i], paramIds[i]);
            this.paramData_.push({ name: names[i], paramId: paramIds[i] });
        }
    },

    /**
     * Callback for the plus image. Adds an input to the end of the block and
     * updates the state of the plus.
     * @this {Blockly.Block}
     * @private
     */
    plus: function () {
        console.log('plus');
        this.addParam_();
    },

    /**
     * Callback for the minus image. Removes an input from the end of the block
     * and updates the state of the minus.
     * @param {string} paramId The ID of the parameter to remove
     * @this {Blockly.Block}
     * @private
     */
    minus: function (paramId) {
        console.log('minus');
        // this.removeParam_(paramId);
        // TODO: This is a dupe of the mutator code, anyway to unify?
        // const block = minusField.getSourceBlock();

        if (this.isInFlyout) {
            return;
        }

        const prevGroupId = Blockly.Events.getGroup();
        Blockly.Events.setGroup(true);
        const oldExtraState = getExtraBlockState(this);
        // block.minus(minusField.args_);
        this.removeParam_(paramId);
        const newExtraState = getExtraBlockState(this);

        if (oldExtraState !== newExtraState) {
            Blockly.Events.fire(
                new Blockly.Events.BlockChange(
                    this,
                    'mutation',
                    null,
                    oldExtraState,
                    newExtraState,
                ),
            );
        }
        Blockly.Events.setGroup(prevGroupId);
    },

    /**
     * Appends a parameter input to the block if one does not already exist.
     * @this {Blockly.Block}
     * @return {!Blockly.Input} The parameter input.
     * @private
     */
    appendParamStatementInput_: function () {
        let paramInput = this.getInput('PARAM_STATEMENT');
        if (!paramInput) {
            this.appendStatementInput('PARAM_STATEMENT');
            this.moveInputBefore('PARAM_STATEMENT', 'REUSABLE_BRICK_STATEMENT');
            paramInput = this.getInput('PARAM_STATEMENT');
            paramInput.setCheck(['Parameter']);
        }
        return paramInput;
    },

    /**
     * Adds an input to the end of the block. If the block currently has no
     * inputs it updates the top 'EMPTY' input to receive a block.
     * @this {Blockly.Block}
     * @private
     */
    addParam_: function (name = null, paramId = null) {
        // const paramNames = this.paramData_.map((param) => param.name);
        name = this.getUniqueName(name);

        // Blockly.Variables.generateUniqueNameFromOptions(
        //     Blockly.Procedures.DEFAULT_ARG,
        //     paramNames,
        // );

        paramId = paramId || Blockly.utils.idGenerator.genUid();

        // create the parameter block and connect it to the statement input
        const thisBlock = this;
        const workspace = thisBlock.workspace;
        const newParamBlock = /**@type {Blockly.BlockSvg}*/ (workspace.newBlock('vmt_parameter'));

        newParamBlock.data = JSON.stringify({ type: 'parameter', name, paramId });
        // const nameField = newParamBlock.getField('PARAMETER_NAME');
        // nameField.setValue(name);

        let paramStatementInput = thisBlock.appendParamStatementInput_();

        // append the parameter block to the statement input
        let nextParamConnection = paramStatementInput.connection;
        if (paramStatementInput.connection.targetConnection) {
            let paramBlock = paramStatementInput.connection.targetConnection.getSourceBlock();
            do {
                nextParamConnection = paramBlock.nextConnection;
                paramBlock = paramBlock.getNextBlock();
            } while (paramBlock);
        }
        nextParamConnection.connect(newParamBlock.previousConnection);

        // Try to render the control - will throw an exception in headless mode
        if (typeof newParamBlock.initSvg == "function") {
            console.log('initSvg >vmt_parameter<', workspace.id);
            newParamBlock.initSvg();
            newParamBlock.render();
            // let the workspace know that the block has finished loading
            // to complete the parameter block creation process
            Blockly.Events.fire(new Blockly.Events.FinishedLoading(workspace));
        }

        this.paramData_.push({ name, paramId });
        return { paramBlock: newParamBlock, name, paramId };
    },

    /**
     * Generates a unique name that is not already in use by the block.
     * @param {string} name The name to make unique.
     * @return {string} A unique name that is not already in use by the block.
     * @this {Blockly.Block}
     * @private
     */
    getUniqueName: function (name = null, paramId = null) {
        const paramNames =
            this.paramData_
                .filter((param) => param.paramId !== paramId)
                .map((param) => param.name);
        if (!name) {
            return Blockly.Variables.generateUniqueNameFromOptions(
                Blockly.Procedures.DEFAULT_ARG,
                paramNames,
            );
        }

        let finalUniqueName = name;
        let iteration = 0;
        do {
            if (paramNames.includes(finalUniqueName)) {
                finalUniqueName = `${name}_${++iteration}`;
            }
            else {
                break;
            }
        } while (iteration < 100);  // prevent infinite loop
        return finalUniqueName;
    },

    /**
     * Called when the field is finished editing. Renames the parameter if the
     * name has changed. If the name is already in use, it will append a number
     * to the end to make it unique.
     * @param {string} _finalName The final value of the field.
     * @this {VmtFieldFlyoutText}
     * @private
     */
    finishEditing_: function (_finalName) {
        console.log('finishEditing_', _finalName);
        const thisField = this;
        /**@type {Blockly.Block} */
        const thisParamReferenceBlock = thisField.getSourceBlock();
        /** @type {{type: string, name: string, paramId: string, parentBlockId: string}} */
        const paramRefData = JSON.parse(thisParamReferenceBlock.data);
        const reusableBlockId = paramRefData.parentBlockId;
        if (paramRefData.name !== _finalName) {
            const workspace = thisParamReferenceBlock.workspace;
            const reusableBlock = workspace.getBlockById(reusableBlockId);
            let parameterBlock = reusableBlock.getInputTargetBlock('PARAM_STATEMENT');
            while (parameterBlock) { // find the parameter block to rename
                if (parameterBlock.data && JSON.parse(parameterBlock.data).paramId === paramRefData.paramId) {
                    break;
                }   // end if
                parameterBlock = parameterBlock.getNextBlock();
            }   // end while
            let finalUniqueName = reusableBlock.getUniqueName(_finalName, paramRefData.paramId);


            // rename all instances of this parameter
            reusableBlock.renameParamBlocks_(paramRefData.paramId, paramRefData.name, finalUniqueName);

            // update the field
            thisField.setValue(finalUniqueName);
            this.paramName_ = finalUniqueName;
            console.log('finishEditing_ finalUniqueName', finalUniqueName);
            reusableBlock.paramData_.find((param) => param.paramId === paramRefData.paramId).name = finalUniqueName;
            thisParamReferenceBlock.data = JSON.stringify({ ...paramRefData, name: finalUniqueName });
            if (parameterBlock) {
                parameterBlock.data = JSON.stringify({ type: 'parameter', name: finalUniqueName, paramId: paramRefData.paramId });
            }
            reusableBlock.saveExtraState();
        }
    },

    /**
     * Removes an input from the block.
     * @param {string} paramId The ID of the parameter to remove.
     * @this {Blockly.Block}
     * @private
     */
    removeParam_: function (paramId) {
        const index = this.paramData_.findIndex((param) => param.paramId === paramId);
        if (index === -1) {
            return;
        }

        this.onBeforeRemoveInput_(paramId);

        // remove the parameter block
        const thisBlock = this;
        const paramStatementInput = thisBlock.getInput('PARAM_STATEMENT');
        if (!paramStatementInput) {
            return;
        }
        /** @type {Blockly.Block} */
        const paramBlock = this.getParameterBlocks().find((block) => JSON.parse(block.data).paramId === paramId);
        const previousConnection = paramBlock.previousConnection.targetConnection;
        const nextConnection = paramBlock.nextConnection.targetConnection;
        previousConnection.connect(nextConnection);
        paramBlock.unplug();
        paramBlock.dispose();
        this.paramData_.splice(index, 1);
        if (this.paramData_.length === 0) {
            this.removeInput('PARAM_STATEMENT');
        }
    },

    /**
     * Called before removing an input. Can be overridden to perform operations
     * before removing an input.
     * @param {string} paramId The name of the input to remove.
     * @this {Blockly.Block}
     * @protected
     */
    onBeforeRemoveInput_: function (paramId) {
        console.log('onBeforeRemoveInput_', paramId);
        this.removeParamBlocks_(paramId);
    },  // end onBeforeRemoveInput_

    /**
     * Returns the list of all parameter blocks used in the current workspace.
     * @this {Blockly.Block}
     * @return {Array<Blockly.Block>|[]} The list of parameter blocks.
     * @private
     */
    getUsedParamReferenceBlocks: function () {
        const allRBBlocks = this.workspace.getAllBlocks();//this.getDescendants();
        return allRBBlocks.filter((block) => block.type === 'vmt_parameter_reference');
    },

    /**
     * Returns the list of parameter reference blocks that are not connected to any field.
     * @this {Blockly.Block}
     * @return {Array<Blockly.Block>|[]} The list of parameter blocks.
     * @private
     */
    getUnpluggedParamReferenceBlocks: function () {
        const allBlocks = this.workspace.getAllBlocks()
        const paramBlocks = [];
        allBlocks.forEach((block) => {
            if (block.type === 'vmt_parameter_reference') {
                if (!block.outputConnection.targetConnection) {
                    paramBlocks.push(block);
                }
            }
        });
        return paramBlocks;
    },

    /**
     * Renames a parameter.
     * @param {string} paramId The name of the source field.
     * @param {string} oldName The old name of the parameter.
     * @param {string} newName The new name of the parameter.
     * @this {Blockly.Block}
     * @private
     * @return {void}
     */
    renameParamBlocks_: function (paramId, oldName, newName) {
        console.log('renameParam', paramId, oldName, newName);
        const paramReferenceBlocks = [...this.getUsedParamReferenceBlocks(), ...this.getUnpluggedParamReferenceBlocks()];
        paramReferenceBlocks.forEach((block) => {
            /** @type {{type: string, name: string, paramId: string}} */
            const blockData = JSON.parse(block.data);
            if (blockData.paramId === paramId) {
                block.setFieldValue(newName, 'PARAMETER_NAME');
                block.data = JSON.stringify({ ...blockData, name: newName });
            }
        });
    },


    getParameterBlocks: function () {
        const allRBBlocks = this.getDescendants();
        const paramBlocks = [];
        allRBBlocks.forEach((block) => {
            if (block.type === 'vmt_parameter') {
                paramBlocks.push(block);
            }
        });
        return paramBlocks;
    },

    /**
     * Removes paremeter blocks associated with the given field name and replaces
     * with  the field/parameter value block(s).
     * @param {string} paramId The name of the source field.
     * @this {Blockly.Block}
     * @private
     * @return {void}
     */
    removeParamBlocks_: function (paramId) {
        console.log('removeParamBlocks_', paramId);
        const thisBlock = this;
        const paramStatementInput = thisBlock.getInput('PARAM_STATEMENT');
        if (!paramStatementInput) {
            return;
        }
        const paramBlock = this.getParameterBlocks().find((block) => JSON.parse(block.data).paramId === paramId);
        const paramInput = paramBlock.getInput('PARAM_INPUT');
        const paramInputBlock = paramInput.connection.targetBlock();
        console.log('paramBlock', paramBlock);


        /** @type {Array<Blockly.Block>|[]} */
        const paramReferenceBlocks = this.getUsedParamReferenceBlocks();
        paramReferenceBlocks.forEach((paramRefBlock) => {
            const blockParamId = JSON.parse(paramRefBlock.data).paramId;
            if (blockParamId === paramId) {
                if (paramInputBlock) { // if there is a block connected to the field
                    const targetConnection = paramRefBlock.outputConnection.targetConnection;
                    if (targetConnection) { // if there is a param ref. block is connected
                        targetConnection.disconnect(); // disconnect the param ref. block
                        const copyData = paramInputBlock.toCopyData(); // copy the block from the parameter input
                        const paramInputBlockCopy = /** @type {Blockly.BlockSvg} */ (
                            Blockly.clipboard.paste(copyData, this.workspace)
                        );
                        // connect the copied block to the param ref. block's prevous connection
                        if (!targetConnection.connect(paramInputBlockCopy.outputConnection)) { // if the connection is not successful
                            paramInputBlockCopy.dispose();
                        }
                    }
                }

                // remove the param ref. block
                paramRefBlock.unplug();
                paramRefBlock.setParent(null);
                paramRefBlock.dispose();
            }
        });

        // remove unuse/unplugged param ref. blocks
        /** @type {Array<Blockly.Block>|[]} */
        const unusdeParamReferenceBlocks = this.getUnpluggedParamReferenceBlocks();
        unusdeParamReferenceBlocks.forEach((block) => {
            block.dispose();
        });

        // remove the parameter block itself
        if (paramInputBlock) {
            paramInputBlock.dispose();
        }
    },
};

/**
 * Updates the shape of the block to have 3 inputs if no mutation is provided.
 * @this {Blockly.Block}
 */
const statementParameterCreateHelper = function () {
    this.paramData_ = [];
    // this.getInput('TOP').insertFieldAt(0, createPlusField(), 'PLUS');
};

Blockly.Extensions.registerMutator(
    'new_statement_parameter_create_with_mutator',
    statementParameterCreateMutator,
    statementParameterCreateHelper,
);

